import { useEffect, useRef, useState } from 'react';

export const argentinaToday = () => {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Argentina/Buenos_Aires', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
  const value = type => parts.find(part => part.type === type).value;
  return `${value('year')}-${value('month')}-${value('day')}`;
};

export const previousClosedWeek = () => {
  const day = new Date(`${argentinaToday()}T12:00:00Z`);
  day.setUTCDate(day.getUTCDate() - ((day.getUTCDay() + 6) % 7) - 1);
  const hasta = day.toISOString().slice(0, 10);
  day.setUTCDate(day.getUTCDate() - 6);
  return { desde: day.toISOString().slice(0, 10), hasta };
};

export const useOtpCommissionExport = ({ operation, cvuId }) => {
  const [dates, setDates] = useState(previousClosedWeek);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [downloaded, setDownloaded] = useState(false);
  const pending = useRef(null);
  useEffect(() => () => { pending.current?.abort(); }, []);
  const changeDate = (key, value) => {
    setDates(current => ({ ...current, [key]: value }));
    setError('');
    setDownloaded(false);
  };
  const download = async event => {
    event.preventDefault();
    if (pending.current) return;
    setError('');
    setDownloaded(false);
    if (!dates.desde || !dates.hasta || dates.desde > dates.hasta || dates.hasta > argentinaToday()) {
      setError('Revisá el rango de fechas. No puede estar invertido ni incluir días futuros.');
      return;
    }
    if ((Date.parse(dates.hasta) - Date.parse(dates.desde)) / 86400000 >= 366) {
      setError('El rango máximo es de 366 días.');
      return;
    }
    const controller = new AbortController();
    pending.current = controller;
    setLoading(true);
    try {
      const query = new URLSearchParams({ operacion: operation, cvu_id: String(cvuId), ...dates });
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/bancos/1touchpay/saldos-operacion/export?${query}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }, signal: controller.signal,
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(typeof data.detail === 'string' ? data.detail : 'No se pudo generar el Excel. Intentá nuevamente.');
      }
      if (!response.headers.get('content-type')?.includes('spreadsheetml')) throw new Error('La respuesta no contiene un Excel válido.');
      const blob = await response.blob();
      if (controller.signal.aborted) return;
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `comisiones_${operation}_${dates.desde}_${dates.hasta}.xlsx`;
      link.dataset.testid = `otp-export-download-file-${operation}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      setDownloaded(true);
    } catch (failure) {
      if (!controller.signal.aborted) setError(failure.message || 'No se pudo descargar el Excel.');
    } finally {
      if (!controller.signal.aborted) setLoading(false);
      if (pending.current === controller) pending.current = null;
    }
  };
  return { dates, changeDate, download, loading, error, downloaded };
};